const useRoleAccess = () => {
  const role = localStorage.getItem("rolenya");
  const isViewer = role === "viewer";
  const isRestrictedMenu = role === "admin_operation" || role === "viewer";
  return { role, isViewer, isRestrictedMenu };
};

export default useRoleAccess;
